import React from 'react';

import styles from './Radio.module.css'
import {Option} from "./types/Option.ts";

interface Props {
    options: Option[];
    selectedValue: string;
    onChange: (value: string) => void;
}

export const Radio: React.FC<Props> = ({options, selectedValue, onChange}) => {
    return (
        <div className={styles.wrapper}>
            {options.map(option => (
                <label className={styles.label} key={option.value}>
                    <input
                        className={styles.radio}
                        type="radio"
                        value={option.value}
                        checked={selectedValue === option.value}
                        onChange={() => onChange(option.value)}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};